import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityDataAccessPermissionSources } from '@api/data-security';

export const getCoreDataSecurityDataAccessPermissionSourcesSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityDataAccessPermissionSources',
	receive: true,
	request: true,
	requestHandler: getDataSecurityDataAccessPermissionSources,
	retainDataOnRequest: true
});
